<template>
  <el-dialog :visible.sync="visiable" width="600px">
    <template slot="title">{{ isEdit ? $t('customer::customer-list::edit_customer') : $t('customer::customer-list::add_customer') }}</template>
    <div>
      <el-form ref="form" :rules="formRules" :model="detail" label-width="80px" :status-icon="true">
        <el-form-item :label="$t('customer::customer-list::last_name')" prop="lastName">
          <el-input v-model="detail.lastName" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item :label="$t('customer::customer-list::first_name')" prop="firstName">
          <el-input v-model="detail.firstName" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item :label="$t('customer::customer-list::email')" prop="email">
          <el-input v-model="detail.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('customer::customer-list::phone')" prop="phone">
          <el-input v-model="detail.phone"></el-input>
        </el-form-item>
        <el-form-item :label="$t('customer::customer-list::customer_level')" prop="customerLevel">
          <el-select
            :placeholder="$t('customer::customer-list::customer_level_select')"
            v-model="detail.customerLevel"
            :popper-append-to-body="false"
            style="width: 100%"
          >
            <el-option v-for="item in levelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('customer::customer-list::tag')" prop="customerTagIds">
          <el-select
            :placeholder="$t('customer::customer-list::select_tag')"
            v-model="detail.customerTagIds"
            style="width: 100%"
            multiple
            collapse-tags
            :multiple-limit="10"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="visiable = false">{{ $t('customer::customer-list::cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('customer::customer-list::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formRules } from '@/views/customer/config'
import { addCustomer, editCustomer } from '@/server/customers'
import { getDicByCode } from '@/server/common'
export default {
  name: 'editDialog',
  props: {
    value: {},
    row: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formRules,
      visiable: this.value,
      detail: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        customerLevel: '',
        customerTagIds: []
      },
      loading: false,
      isEdit: false,
      levelList: [],
      tagList: []
    }
  },
  async mounted() {
    const tag = await getDicByCode(8)
    if (tag.data.code === this.$code) {
      this.tagList = tag.data.data
    }
    const level = await getDicByCode(9)
    if (level.data.code === this.$code) {
      this.levelList = level.data.data
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmSend()
        }
      })
    },
    async confirmSend() {
      this.loading = true
      const { data } = this.isEdit ? await editCustomer(this.detail) : await addCustomer({ ...this.detail })
      this.loading = false
      if (data.code === this.$code) {
        this.visiable = false
        this.$message({
          type: 'success',
          message: `${this.isEdit ? this.$t('customer::customer-list::edit_success') : this.$t('customer::customer-list::add_success')}`
        })
        this.$emit('submit')
      }
    }
  },
  watch: {
    value(val) {
      this.visiable = val
    },
    visiable(val) {
      this.$emit('input', val)
    },
    row: {
      handler(val) {
        console.log(val)
        this.detail = {
          ...val,
          customerTagIds: []
        }
        if (val.id) {
          this.isEdit = true
          this.detail.customerTagIds = (val.customerTags || []).map(item => item.customerTagId)
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
